import React, { useState } from "react";

/// React router dom
import { Link } from "react-router-dom";

/// images
import logo from "../../../img/app.png";
import logoText from "../../../images/logo-text.png";

const NavHader = () => {
  const [toggle, setToggle] = useState(false);
  return (
    <div className="nav-header" style={{ zIndex: "12" }}>
      <Link to="/" className="brand-logo">
        <img className="logo-abbr" src={logo} alt="" />
        {/* <img className="" src={logoText} alt="" /> */}
        <span className="logo-compact" style={{ color: "#060047", fontSize: "2rem" }}>
          Marka
        </span>

        {/* <img className="brand-title" src={logoText} alt="" /> */}
        <span className="brand-title" style={{ color: "#060047", fontSize: "2rem" }}>
          Marka
        </span>
      </Link>

      <div className="nav-control" onClick={() => setToggle(!toggle)}>
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
